import React, { memo } from 'react'
import styled from 'styled-components'
const Div = styled.div`
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;


.loader--ripple {
    display: inline-block;
    position: relative;
    height: 64px;
    width: 64px;    
}

.loader--ripple div {
    position: absolute;
    animation: loader--ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    border: 4px solid;
    border-radius: 50%;
    opacity: 1;
}

.loader--ripple div:nth-child(2) {
    animation-delay: -0.5s;
}

@keyframes loader--ripple {
    0% {
        top: 28px;
        left: 28px;
        opacity: 1;
        height: 0;
        width: 0;
    }

    100% {
        top: -1px;
        left: -1px;
        opacity: 0;
        height: 58px;
        width: 58px;
    }
}
`
const Loading = memo(() => {
    return (<Background>
        <Div>
            <div className="loader--ripple ">
                <div></div>
                <div></div>
            </div>
        </Div>
    </Background>
    )
})

export default Loading
const Background = styled.div`
    display: grid;
    position: absolute;
    top: 0px;
    right: 0px;
    left : 0px;
    bottom: 0px;
    width: 100vw;
    height: 100vh;
    z-index: 100000;
    place-items: center;
    background-color: lightgrey;
    opacity: 0.9;
`